/**
 * Scroll reveals, ported from wp-tonale. Markup renders `animate <variant>
 * <direction>`, which styles nothing; swapping it for `animated` here means the
 * hidden state only exists once this script can undo it. `intersecting` is
 * added when the element reaches the viewport.
 */
export function initReveal() {
	if (!('IntersectionObserver' in window)) return;

	const io = new IntersectionObserver(
		(entries) => {
			// Elements entering together (a tall screen shows them all at once) still play one after the other.
			let index = 0;
			entries
				.filter((entry) => entry.isIntersecting || entry.boundingClientRect.bottom < 0)
				.forEach((entry) => {
					entry.target.style.setProperty('--reveal-index', index);
					index += entry.target.children.length;
					entry.target.classList.add('intersecting');
					io.unobserve(entry.target);
				});
		},
		{ threshold: 0, rootMargin: '0px 0px -10% 0px' }
	);

	document.querySelectorAll('.animate').forEach((el) => {
		el.classList.replace('animate', 'animated');
		io.observe(el);
	});
}
